import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import { MyInputNumeric, MyInput } from "./";

class PaymentInput extends React.Component {
	isNumberCheck = () => {
		if (this.props.isNumber) {
			return <MyInputNumeric name={this.props.name} />;
		} else
			return (
				<MyInput
					name={this.props.name}
					EUR={this.props.EUR}
					isMandateField={this.props.isMandateField}
					isRequiredField={this.props.isRequiredField}
          customValidationRegex={this.props.customValidationRegex}
          customValidationMessage={this.props.customValidationMessage}
          customValidationMessageMLKey={this.props.customValidationMessageMLKey}
				/>
			);
	};
	render() {
		return (
			<Container>
				<Row>
					<Col>{this.isNumberCheck()}</Col>
				</Row>
				<Row>
					<Col>
						<hr className="payment-input-label-line" />
					</Col>
				</Row>
			</Container>
		);
	}
}

export default PaymentInput;
